module.exports = __webpack_public_path__ + "media/pt_pt_s1_Alfonso.32dfc50f.mp3";